import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ListGroup,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { AiOutlineRollback, AiFillEdit } from "react-icons/ai";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateAgent,
  getAgentById,
  resetAgentUpdate,
  resetAgentDetails,
  getAllAgents,
} from "../features/agent/agentSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";

const UpdateAgent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  //Agent States
  const [agentImage, setAgentImage] = useState("");
  const [agentFullName, setAgentFullName] = useState("");
  const [agentNid, setAgentNid] = useState("");
  const [agentPhoneNumber, setAgentPhoneNumber] = useState("");
  const [agentEmail, setAgentEmail] = useState("");
  const [agentCommission, setAgentCommission] = useState("");
  const [agentAddress, setAgentAddress] = useState("");
  // const [agentList, setAgentList] = useState([]);

  //user selector
  const { userInfo } = useSelector((state) => state.user);

  const {
    agent,

    isDetailsLoading,
    isDetailsError,
    isDetailsSuccess,
    detailsErrorMessage,

    isUpdateLoading,
    isUpdateError,
    isUpdateSuccess,
    updateErrorMessage,
  } = useSelector((state) => state.agent);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login to Get Access", { position: "top-center" });
      navigate("/login");
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (isDetailsError) {
      toast.error(detailsErrorMessage, { position: "top-center" });
    } else if (isDetailsSuccess) {
      setAgentImage(agent.image);
      setAgentFullName(agent.fullName);
      setAgentNid(agent.nid);
      setAgentPhoneNumber(agent.phone);
      setAgentEmail(agent.email);
      setAgentCommission(agent.commission);
      setAgentAddress(agent.address);
    } else {
      dispatch(getAgentById(params.id));
    }
  }, [isDetailsSuccess, isDetailsError, detailsErrorMessage]);

  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Agent Updated Successfully", { position: "top-center" });
      navigate("/agentList");
    }
  }, [isUpdateSuccess, isUpdateError, updateErrorMessage]);

  const updateHandler = () => {
    const agent = {
      image: agentImage,
      fullName: agentFullName,
      nid: agentNid,
      phone: agentPhoneNumber,
      email: agentEmail,
      commission: agentCommission,
      address: agentAddress,
    };
    dispatch(updateAgent({ id: params.id, agent }));
  };

  // useEffect(() => {
  //   if (isDetailsError) {
  //     toast.error(detailsErrorMessage, { position: "top-center" });
  //   } else if (isDetailsSuccess) {
  //     setAgentList(agent);
  //   } else {
  //     dispatch(getAllAgents());
  //   }
  // }, [isDetailsSuccess, isDetailsError, isDetailsError, agent]);

  useEffect(() => {
    return () => {
      dispatch(resetAgentDetails());
      dispatch(resetAgentUpdate());
    };
  }, [dispatch]);

  const uploadImageFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `/api/v1/upload${agentImage ? `/${agentImage.slice(8)}` : ""}`,
        formData,
        config
      );
      setAgentImage(data);
    } catch (error) {
      console.error(error);
    }
  };
  //Image Upload Agent
  // const uploadImageHandler = async (e) => {
  //   const file = e.target.files[0];
  //   const formData = new FormData();
  //   formData.append("agentImage", file);
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     };

  //     const { data } = await axios.post(
  //       `/api/v1/upload${agentImage ? `/${agentImage.slice(8)}` : ""}`,
  //       formData,
  //       config
  //     );
  //     setAgentImage(data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  return (
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []),
    (
      <>
        {isDetailsLoading || isUpdateLoading ? (
          <Loader />
        ) : isDetailsError ? (
          <h4 variant="danger">{detailsErrorMessage}</h4>
        ) : (
          <Container fluid className="my-4">
            <h2 style={{ fontWeight: "bold " }} className="mb-4 text-center">
              Update Agent
            </h2>

            <Form>
              <Row>
                {/* Column for Upload Files  */}
                <Col sm={12} md={4} lg={3}>
                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black p-3 fw-bold text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Upload Agent Image
                    </Card.Header>
                    <Card.Body className="text-center">
                      <Card.Img
                        cascade
                        className="img-fluid rounded"
                        src={
                          agentImage !== ""
                            ? agentImage
                            : "http://bootdey.com/img/Content/avatar/avatar7.png"
                        }
                        style={{ height: "20vh" }}
                      />
                      <div className="small font-italic text-muted mt-3">
                        JPG or PNG no larger than 5 MB
                      </div>
                      <Form.Group controlId="image 1">
                        <Form.Label className="py-3">Upload Image</Form.Label>
                        <Form.Control
                          // required
                          className="mb-3 rounded"
                          type="file"
                          id="image-file"
                          label="Agent Image"
                          controlId="agentImage"
                          onChange={uploadImageFileHandler}
                        ></Form.Control>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Column For Form */}
                <Col sm={12} md={8} lg={9}>
                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black p-3 fw-bold text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Update Agent Information
                    </Card.Header>

                    <Card.Body className="fw-bold">
                      <Row>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="Name">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder={
                                agentFullName === ""
                                  ? "Full Name is Required"
                                  : "Enter Agent Full Name"
                              }
                              value={agentFullName}
                              onChange={(e) => setAgentFullName(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="NIDNumber">
                            <Form.Label>NID Number</Form.Label>
                            <Form.Control
                              required
                              type="number"
                              placeholder={
                                agentNid === ""
                                  ? "Nid is Required"
                                  : "Enter NID Number"
                              }
                              value={agentNid}
                              onChange={(e) => setAgentNid(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="PhoneNumber">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              required
                              type="number"
                              placeholder={
                                agentPhoneNumber === ""
                                  ? "Phone Number is Required"
                                  : "Enter Phone Number"
                              }
                              value={agentPhoneNumber}
                              onChange={(e) =>
                                setAgentPhoneNumber(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="AgentEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder={
                                agentEmail === ""
                                  ? "Email is Required"
                                  : "Enter Email Address"
                              }
                              value={agentEmail}
                              onChange={(e) => setAgentEmail(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="Comission">
                            <Form.Label>Commission</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder={
                                agentCommission === ""
                                  ? "Commission is Required"
                                  : "Enter Agent Comission"
                              }
                              value={agentCommission}
                              onChange={(e) =>
                                setAgentCommission(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={8} lg={8}>
                          <Form.Group controlId="AgentAddress">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={
                                agentAddress === ""
                                  ? "Address is Required"
                                  : "Enter Address"
                              }
                              value={agentAddress}
                              onChange={(e) => setAgentAddress(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-4">
                        <Col sm={12} md={6} lg={6} className="px-4">
                          <Row>
                            <Button
                              variant="outline-primary"
                              type="submit"
                              className="rounded"
                              onClick={updateHandler}
                            >
                              <AiFillEdit className="mb-1" size={18} /> Update
                              Agent
                            </Button>
                          </Row>
                        </Col>

                        <Col sm={12} md={6} lg={6} className="px-4">
                          <Row>
                            <LinkContainer to="/agentList">
                              <Button
                                variant="outline-secondary"
                                type="submit"
                                className="rounded"
                              >
                                <AiOutlineRollback className="mb-1" size={18} />{" "}
                                Go Back To List
                              </Button>
                            </LinkContainer>
                          </Row>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Container>
        )}
      </>
    )
  );
};

export default UpdateAgent;
